import { z } from 'zod';

export const AddressSchema = z.object({
    type: z.enum(['main', 'mailing']).optional(),
    street: z.string().optional(),
    number: z.string().optional(),
    complement: z.string().optional(),
    neighborhood: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    proofOfAddressFile: z.any().optional(), // ✅ Validação específica feita no Controller
    proofOfAddressUrl: z.string().optional(),
    fullAddress: z.string().optional(),
    id: z.string().optional(),
    zipCode: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
});

export type Address = z.infer<typeof AddressSchema>; 